import { get, put } from './httpservices'
import { store } from '../store/store'
import { router } from '../router/index'
import { userprofile } from './authservices'

export async function getcompany_id() {
	if (store.state.auth.user_data.company_id === '') {
		await userprofile()
		return store.state.auth.user_data.company_id
	} else {
		return store.state.auth.user_data.company_id
	}
}

export async function getNotifications() {
	let company_id = await getcompany_id()
	if (company_id) {
		let resp
		try {
			resp = await get('distributor/notifications/' + company_id)
			return resp.data
		} catch (e) {
			console.log(e)
			// router.push('/500');
			return e.response
		}
	}
}

export async function getRecentNotifications() {
	store.commit('background')
	let company_id = await getcompany_id()
	if (company_id) {
		let resp
		try {
			resp = await get('distributor/recent/notifications/' + company_id)
			if (!resp.data.dataset && !resp.data.data) {
				store.commit('errorMessage', '')
			}
			return resp.data
		} catch (e) {
			console.log(e)
			// router.push('/500');
			return e.response
		}
	}
}

export async function getNotification(id, type) {
	let resp
	try {
		resp = await get('distributor/notification/' + id + '/' + type)
		return resp.data
	} catch (e) {
		console.log(e)
		// router.push('/500');
		return e.response
	}
}

export async function readNotification(notification_id) {
	store.commit('background')
	let resp
	try {
		resp = await put('distributor/read-notification/' + notification_id)
		if (!resp.data.dataset && !resp.data.data) {
			store.commit('errorMessage', '')
		}
		return resp.data
	} catch (e) {
		console.log(e)
		// router.push('/500');
		return e.response
	}
}

export async function getCalendar(list_id) {
	let resp
	try {
		resp = await get('distributor/list/' + list_id)
		return resp.data
	} catch (e) {
		console.log(e)
		// router.push('/500');
		return e.response
	}
}

export async function getDashboardData() {
	let company_id = await getcompany_id()
	if (company_id) {
		let resp
		try {
			resp = await get('distributor/dashboard/' + company_id)
			return resp.data
		} catch (e) {
			console.log(e)
			// router.push('/500');
			return e.response
		}
	}
}
